import React from "react";
import { useHistory } from "react-router-dom";
import { MoreOutlined, SearchOutlined } from "@ant-design/icons";
import { Space, Table, Switch, Modal, message, Input, Select, Dropdown, Menu, Tag, Card, Checkbox } from "antd";
import { httpRequest } from "../../helpers/api";
import { BaseResponseProps } from "../../types/config.type";
import { UserProperties, initialUser, RoleList, ListUserQuery } from "../../types/user.type";
import useFetchList from "../../hooks/useFetchList";
import { formatDate } from "../../helpers/format";
import Text from "antd/lib/typography/Text";
import { getErrorMessage } from "../../helpers/errorHandler";
import { showRoleName } from "../../helpers/auth";
import CustomPagination from "../../components/CustomPagination";
import HeaderSection from "../../components/HeaderSection";
import Filter from "../../components/Filter";
// import { ProfileProperties } from "../../types/profile.type";
// import { getNotifEmailAddress } from "../../helpers/profile";

interface ResponseProps extends BaseResponseProps<Omit<UserProperties, "createdAt" | "updatedAt">> {}

type Props = {};

const Public = (props: Props) => {
	const history = useHistory();

	const [isLoadingUpdate, setIsLoadingUpdate] = React.useState(false);
	const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
	const [tmpData, setTmpData] = React.useState<UserProperties>(initialUser);
	const { isLoading, data, pagination, setData, setSearch, setQuery, changePage } = useFetchList<
		UserProperties,
		ListUserQuery
	>({
		endpoint: "users/customers",
		initialQuery: {
			filterUserType: "customer",
		},
	});

	// React.useEffect(() => {
	// 	setQuery((q) => ({
	// 		...q,
	// 		filterUserType: Object.keys(RoleList).join(","),
	// 	}));
	// 	// eslint-disable-next-line
	// }, [location.pathname]);

	const handleStatusChange = async () => {
		try {
			setIsLoadingUpdate(true);
			let newData = [];
			newData = data.map((item) => {
				if (item.userId === tmpData.userId) {
					return {
						...item,
						statusLoading: true,
					};
				}
				return item;
			});

			const newStatus = tmpData.status === "active" ? "inactive" : "active";

			const res = await httpRequest.patch<ResponseProps>("/users/" + tmpData.userId + "/update-customer", {
				status: newStatus,
			});
			newData = data.map((item) => {
				if (item.userId === res.data.payload.userId) {
					return {
						...item,
						status: res.data.payload.status,
						statusLoading: false,
					};
				}
				return item;
			});
			setData(newData);

			message.success("Success change " + tmpData.name + " status.");
			setIsModalVisible(false);
			setTmpData(initialUser);
			setIsLoadingUpdate(false);
		} catch (error: any) {
			message.error(error.data.message);
			setIsModalVisible(false);
			setTmpData(initialUser);
			setIsLoadingUpdate(false);
		}
	};

	const handleClickDetail = (e: UserProperties) => {
		history.push(`/public-users/${e.userId}`);
	};

	const { Option } = Select;

	const handleChangeStatus = (status: string) => {
		if (status !== "all") {
			setQuery((oldVal) => ({ ...oldVal, filterStatus: status }));
		} else {
			setQuery((oldVal) => ({ ...oldVal, filterStatus: "" }));
		}
	};

	const columns = [
		{
			title: "FULL NAME",
			dataIndex: "name",
			key: "name",
			render: (text: string, record: UserProperties) => {
				return (
					<div
						className="table-link"
						onClick={() => handleClickDetail(record)}
					>
						{text}
					</div>
				);
			},
		},
		{
			title: "EMAIL ADDRESS",
			dataIndex: "email",
			key: "email",
			render: (email: string) => <Text>{email}</Text>,
		},

		{
			title: "STATUS",
			key: "status",
			dataIndex: "status",
			render: (status: any, record: UserProperties) => (
				<>
					<Switch
						checked={status === "active"}
						onChange={() => {
							setIsModalVisible(true);
							setTmpData(record);
						}}
					/>
				</>
			),
		},
		{
			title: "REQUEST DELETE ACCOUNT",
			key: "deleteAcc",
			dataIndex: "deleteAcc",
			render: (status: any, record: UserProperties) => (
				<>
					<Tag color={record.authInfo?.isBlocked ? "red" : "blue"}>
						{record.authInfo?.isBlocked ? "Yes" : "No"}
					</Tag>
				</>
			),
		},
		{
			title: "CREATED",
			dataIndex: "createdAt",
			key: "createdAt",
			render: (createdAt: any) => <div>{formatDate(createdAt)}</div>,
		},
		{
			title: "",
			key: "action",
			render: (_: any, record: UserProperties) => (
				<Dropdown
					overlay={() => menu(record)}
					placement="bottomRight"
				>
					<MoreOutlined style={{ cursor: "pointer" }} />
				</Dropdown>
			),
		},
	];

	const handleClick = async (key: string, record: UserProperties) => {
		if (key === "edit") {
			history.push({
				pathname: `/users/${record.userId}/edit`,
			});
		} else if (key === "change-password") {
			history.push({
				pathname: `/users/${record.userId}/change-password`,
			});
		}
		// else if (key === "send-email-verification-link") {
		// 	const profile = await fetchUserProfile(record.userId);
		// 	sendEmailVerificationLink(getNotifEmailAddress(profile));
		// }
		else if (key === "send-email-forgot-password") {
			// const profile = await fetchUserProfile(record.userId);
			sendEmailForgotPasswordLink(record.email);
		}
	};

	// const fetchUserProfile = async (userId: string) => {
	// 	let { data } = await httpRequest.get<BaseResponseProps<ProfileProperties>>("users/" + userId + "/profile");
	// 	return data.payload;
	// };

	// const sendEmailVerificationLink = (email: string) => {
	// 	setIsLoadingUpdate(true);
	// 	httpRequest
	// 		.post("/auth/send-email-verification", {
	// 			platform: "cms",
	// 			email,
	// 		})
	// 		.then((res) => {
	// 			setIsLoadingUpdate(false);
	// 			message.success("Email verification link has been sent successfully");
	// 		})
	// 		.catch((err) => {
	// 			message.error("Failed to send email verification link. " + getErrorMessage(err));
	// 			setIsLoadingUpdate(false);
	// 		});
	// };

	const sendEmailForgotPasswordLink = (email: string) => {
		setIsLoadingUpdate(true);
		httpRequest
			.post("/auth/forgot-password/confirmation-link", {
				platform: "cms",
				email,
			})
			.then((res) => {
				setIsLoadingUpdate(false);
				message.success("Link reset password has been sent successfully");
			})
			.catch((err) => {
				message.error("Failed to send link reset password. " + getErrorMessage(err));
				setIsLoadingUpdate(false);
			});
	};

	const menu = (record: UserProperties) => (
		<Menu onClick={(e) => handleClick(e.key, record)}>
			<Menu.Item key="edit">Edit User</Menu.Item>
			<Menu.Item key="change-password">Change Password</Menu.Item>
			<Menu.Item key="send-email-forgot-password">Send Reset Password Link</Menu.Item>
			{/* <Menu.Item key="send-email-verification-link">Send Email Verification Link</Menu.Item> */}
		</Menu>
	);

	return (
		<React.Fragment>
			<Space
				direction="vertical"
				size="large"
			>
				<HeaderSection title="Public User (Internal Usage Only)">
					<Filter maxWidth="100%">
						<Filter.Medium>
							<Input
								className="outer-shadow"
								placeholder="Search by Name, Phone number or Email"
								suffix={<SearchOutlined />}
								allowClear
								onChange={(e) => setSearch(e.target.value)}
							/>
						</Filter.Medium>

						<Filter.Custom
							md={4}
							xs={12}
						>
							<Select
								virtual={true}
								className="outer-shadow"
								style={{ width: "100%" }}
								onChange={handleChangeStatus}
								placeholder="Status"
							>
								<Option value="all">All</Option>
								<Option value="active">Active</Option>
								<Option value="inactive">Non Active</Option>
							</Select>
						</Filter.Custom>

						<Filter.Custom
							md={6}
							xs={12}
						>
							<Checkbox
								onChange={(e) => {
									if (e.target.checked) {
										setQuery((oldVal) => ({ ...oldVal, filterIsBlocked: true }));
									} else {
										setQuery((oldVal) => ({ ...oldVal, filterIsBlocked: false }));
									}
								}}
							>
								Is Request Delete Account
							</Checkbox>
						</Filter.Custom>
					</Filter>
				</HeaderSection>
				<Card
					bordered={false}
					size="small"
				>
					<Table
						loading={isLoading}
						columns={columns}
						dataSource={data}
						pagination={false}
						scroll={{ x: "100%" }}
					/>
					<CustomPagination
						current={pagination.page}
						total={pagination.totalData}
						defaultPageSize={pagination.perPage}
						pageSize={pagination.perPage}
						onChange={changePage}
					/>
				</Card>
			</Space>

			<Modal
				title="Update status confirmation"
				open={isModalVisible}
				onOk={handleStatusChange}
				onCancel={() => {
					setIsModalVisible(false);
					setTmpData(initialUser);
				}}
				okText="Yes"
				confirmLoading={isLoadingUpdate}
				okButtonProps={{ type: "primary" }}
			>
				<p>
					Are you sure want to change <b>"{tmpData.name}"</b> status to{" "}
					<b>"{tmpData.status === "active" ? "Inactive" : "Active"}"</b>?.{" "}
					{tmpData.status === "active"
						? 'If this user status is changed to "Inactive", then this user cannot login to the MedEasy'
						: 'If this user status is changed to "Active", then this user can Sign In to MedEasy'}
				</p>
			</Modal>
		</React.Fragment>
	);
};
export default Public;
